import { useEffect, useMemo, useState } from 'react';

import { getConfig } from '@edx/frontend-platform';
import { getCountryList, getLocale, useIntl } from '@edx/frontend-platform/i18n';
import PropTypes from 'prop-types';

import Select from '../../common-components/Select';
import messages from '../messages';

const CountryCityFields = ({
  additionalInformation,
  onSelect,
}) => {
  const [cityList, setCityList] = useState([]);

  const { formatMessage } = useIntl();

  const lang = getLocale();

  const cityListUrl = useMemo(
    () =>
      `${getConfig().CITIES_API}/datastore_search?resource_id=${
        getConfig().RESOURCE_ID_CITIES_API
      }&limit=${getConfig().LIMIT_CITIES_API}`,
    [lang]
  );
  const countryList = useMemo(() => getCountryList(lang), [lang]);

  function transformCityData(item, lang) {
    const cityHeb = item['שם_ישוב']?.trim();
    const cityEng = item['שם_ישוב_לועזי']?.trim();
 
    return {
      id: String(item['_id']),
      country: 'IL',
      city:
        lang === 'he'
          ? cityHeb || cityEng
          : cityEng || cityHeb, 
    };
  }


  useEffect(() => {
    const fetchCityListData = async () => {
      try {
        const response = await fetch(cityListUrl);
        const result = await response.json();
        const cities = result.result.records.map((item) => transformCityData(item, lang));
        setCityList(cities);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching data', error);
      }
    };

    fetchCityListData();
  }, [cityListUrl]);

  const cityOptions = useMemo(
    () =>
      cityList
        .map((city) => ({ id: city.id, label: city.city, value: city.city }))
        .sort((a, b) =>
          a.label.localeCompare(b.label, lang === 'en' ? 'en' : 'he')
        ),
    [cityList, lang]
  );

const selectedCountryCode = additionalInformation.country?.trim() || 'IL';
const selectedCountry = countryList.find(country => country.code === selectedCountryCode);

  return (
    <div className="country-city-inputs flex-center-column gap-20">
      <Select
        label={formatMessage(messages['customized.courses.country.label'])}
        value={selectedCountry?.name || ''}
        options={
          countryList
            .map(country => ({ id: country.code, value: country.name }))
            .sort((a, b) => a.value.localeCompare(b.value))
        }
        showLabelAsPlaceholder
        onChange={(country) => onSelect('country', country.id)}
      />
      <Select
        label={additionalInformation.country !== 'IL' && !additionalInformation.city ? '-----' : formatMessage(messages['customized.courses.city.label'])}
        disabled={!additionalInformation.country || additionalInformation.country !== 'IL'}
        value={additionalInformation.city || ''}
        options={cityOptions}
        showLabelAsPlaceholder
        onChange={(city) => {
          onSelect('city', city.value);
          if (additionalInformation.country !== 'IL') {
            onSelect('city', '');
          }
        }}
      />
    </div>
  );
};

CountryCityFields.propTypes = {
  additionalInformation: PropTypes.shape({
    country: PropTypes.string,
    city: PropTypes.string,
  }).isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default CountryCityFields;
